import type {Place} from '../sim/expedition';
import {etchingDefs} from './worldEtching';
import {worldComposition} from './worldComposition';
import {paintedWorld} from './worldPainting';
export {worldComposition} from './worldComposition';
const safeId=(id:string)=>id.replace(/[^A-Za-z0-9_-]/g,'_');
const dimensions=(aspect:number)=>Math.round(700*Math.max(.6,Math.min(3,Number.isFinite(aspect)?aspect:1)));
function scene(p:Place,event:string,aspect:number,instanceId:string,small:boolean):string {
 const w=dimensions(aspect),id=safeId(`painted-${instanceId}-${p.seed}-${event}`),c=worldComposition(p);
 return `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="700" viewBox="0 0 ${w} 700" preserveAspectRatio="xMidYMid meet" data-world-art="${p.biome}" data-biome-signature="${p.biome}" data-composition="${c.family}" data-world-family="${c.family}" data-variant="${c.variant}" data-world-seed="${p.seed}"${small?' class="voyage-route-art" aria-hidden="true"':''}>${etchingDefs(id)}<path d="M0 0H${w}V700H0Z" fill="#d9c398"/>${paintedWorld({p,event,id,w,c,small})}</svg>`;
}
/** Complete procedural painting uploaded behind actors, sized for the actual stage. */
export function illustratedWorld(p:Place,event:string=p.encounter,aspect=1,instanceId='world'):string {
 return scene(p,event,aspect,instanceId,false);
}
export const worldBackground=illustratedWorld;
/** All scenery shares background depth ordering; no pen stroke covers standing or fallen actors. */
export function marginalia(p:Place,event:string,aspect=1):string {
 const w=dimensions(aspect),c=worldComposition(p);
 return `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="700" viewBox="0 0 ${w} 700" preserveAspectRatio="xMidYMid meet" data-world-foreground="empty" data-composition="${c.family}" data-event-landmark="${safeId(event)}"></svg>`;
}
/** Same geography/encounter as the scene; only fine pigment wear is reduced. */
export function routeMiniature(p:Place,event:string=p.encounter,instanceId='route'):string {
 return scene(p,event,12/7,`route-${instanceId}`,true);
}
